import { ReactNode } from "react";
import styles from "./menu-select-title.module.css";

export type MenuSelectTitleProps = {
  children: ReactNode;
};

export function MenuSelectTitle({ children }: MenuSelectTitleProps) {
  return <div className={styles.Container}>{children}</div>;
}
